export default {
  topMenu: {
    openSettings: 'Einstellungen öffnen',
    showAbout: 'Allgemeine Informationen',
    about: 'Über ORS',
    pinSidebar: 'Seitenleiste dauerhaft anzeigen',
    settingsTooltip: 'Klicken Sie hier, um Einstellungen anzzupassen'
  }
}
